import { Label } from 'components/ui/label';
import { ToggleGroup, ToggleGroupItem } from 'components/ui/toggle-group';
import { Square } from 'lucide-react';
import { ReactNode } from 'react';

const ToggleGroupComponent = ({ value, onChange, header, options, optionFormatter }: IToggleGroupComponent) => {
  return (
    <ToggleGroup
      type="multiple"
      variant="outline"
      spacing={2}
      size="sm"
      className="block"
      value={value}
      onValueChange={value => {
        if (value) onChange(value);
      }}
    >
      {typeof header === 'string' ? <Label>{header}</Label> : header}
      <div className="flex flex-wrap gap-2">
        {options.map(opt => (
          <ToggleGroupItem
            key={opt}
            value={opt}
            aria-label={opt}
            className="data-[state=on]:bg-transparent data-[state=on]:*:[svg]:fill-sq-medium data-[state=on]:*:[svg]:stroke-sq-medium"
          >
            <Square />
            {optionFormatter ? optionFormatter(opt) : opt}
          </ToggleGroupItem>
        ))}
      </div>
    </ToggleGroup>
  );
};

interface IToggleGroupComponent {
  value: string[];
  onChange: (value: string[]) => void;
  header?: ReactNode;
  options: string[];
  optionFormatter?: (opt: string) => React.ReactNode;
}

export default ToggleGroupComponent;
